var map = {
	"./symbol_0.png": 83124,
	"./symbol_1.png": 4253,
	"./symbol_10.png": 23177,
	"./symbol_11.png": 98976,
	"./symbol_12.png": 96539,
	"./symbol_2.png": 20486,
	"./symbol_3.png": 5583,
	"./symbol_4.png": 93360,
	"./symbol_5.png": 25465,
	"./symbol_6.png": 11458,
	"./symbol_7.png": 75115,
	"./symbol_8.png": 78460,
	"./symbol_9.png": 12325
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4655;